import {useGetLimitsByType, getUsageFromLimits} from '../../../../limits';
import type {MonthlyUsage} from '../../../../limits/get-usage-from-limits';

export const useGetPowerAiLiveNoteMonthlyUsage = (): {
    monthlyUsage: MonthlyUsage | null | undefined;
    isLoading: boolean;
    error?: boolean;
} => {
    const {isLoading, limits, errorMessage} = useGetLimitsByType('AI_TRANSCRIPTIONS');

    const monthlyUsage = getUsageFromLimits(limits);

    return {
        monthlyUsage,
        isLoading,
        error: Boolean(errorMessage || (!isLoading && !monthlyUsage)),
    };
};
